export default __webpack_public_path__ + "img/community.f03370a0.svg";